import React, { ElementType, useState } from 'react';
import { Helmet } from 'react-helmet';
import { WeekDayForCourier } from './WeekDayForCourier/WeekDayForCourier';

import dayjs, { Dayjs } from 'dayjs';
import {
  CalendarFetchByWeek,
  getMondayGivenWeekDate,
  getSundayGivenWeekDate,
} from 'components/OrderListTable/CalendarFetch/CalendarFetchByWeek';
import { useFetchShiftByRegion } from 'hooks/useFetchShift';
import { isSameDayAsFilterDay } from 'utils/date';
import { getWeekArray } from './Shift';

import './Shift.scss';
import { ReqEnum } from '../../const/requestStatus';

import './Shift.scss';
import { ShiftCourierWithDateJson } from '../../const/ShiftConst';
import { Region } from '../../types/orderTypes';

function OneWeekOfDaysForCourier({
  courierListBookedWeek,
  WeekDay,
  weekOfDates,
  region,
}: {
  courierListBookedWeek: ShiftCourierWithDateJson[];
  WeekDay: ElementType;
  weekOfDates: Dayjs[];
  region: Region;
}): any {
  return (
    <div className="oneWeek">
      {weekOfDates.map((date: Dayjs, index: number) => {
        const shiftDate: Dayjs = courierListBookedWeek[index].date;
        if (!isSameDayAsFilterDay(shiftDate, date)) {
          return (
            <WeekDay
              key={`${index} - ${dayjs(date).format('DD/MM')}`}
              courierListBookedObj={[]}
              date={date}
              region={region}
            />
          );
        }

        if (isSameDayAsFilterDay(shiftDate, date)) {
          return (
            <WeekDay
              key={`${index} - ${dayjs(date).format('DD/MM')}`}
              courierListBookedObj={courierListBookedWeek[index]}
              date={date}
              region={region}
            />
          );
        } else {
          return (
            <WeekDay
              key={`${index} - ${dayjs(date).format('DD/MM')}`}
              courierListBookedObj={[]}
              date={date}
              region={region}
            />
          );
        }
      })}
    </div>
  );
}

export function OneWeekForCourier({
  WeekDay,
  region,
}: {
  WeekDay: ElementType;
  region: Region;
}): JSX.Element {
  // add way to see date in data structure
  const [startDate, setStartDate] = useState<Dayjs>(getMondayGivenWeekDate());
  const [endDate, setEndDate] = useState<Dayjs>(getSundayGivenWeekDate());
  const [courierListBookedFetched, fetchStatus] = useFetchShiftByRegion(
    startDate,
    endDate,
    region
  );

  const [weekOfDates, setWeekOfDates] = useState<Dayjs[]>(
    getWeekArray(startDate, endDate)
  );

  const fetchValues = values => {
    const { fetchStartDate, fetchEndDate } = values;
    setStartDate(fetchStartDate);
    setEndDate(fetchEndDate);
    setWeekOfDates(getWeekArray(fetchStartDate, fetchEndDate));
  };

  return (
    <div className="shiftCalendar">
      <div className="calenderBox">
        <div className="calendarTable">
          <div className="positionWeek">
            <CalendarFetchByWeek
              fetchValues={fetchValues}
              givenStartDate={startDate}
              givenEndDate={endDate}
            />
          </div>

          {fetchStatus === ReqEnum.SUCCESS && (
            <OneWeekOfDaysForCourier
              courierListBookedWeek={courierListBookedFetched}
              WeekDay={WeekDay}
              weekOfDates={weekOfDates}
              region={region}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export function ShiftForCourier({ region }: { region: Region }): JSX.Element {
  return (
    <>
      <Helmet>
        <title>My Shifts</title>
      </Helmet>
      <OneWeekForCourier WeekDay={WeekDayForCourier} region={region} />
    </>
  );
}
